import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {IonicModule} from '@ionic/angular';
import {UnrAddCommentComponent} from './components/add-comment/add-comment.component';

@NgModule({
  declarations: [
    UnrAddCommentComponent
  ],
  exports: [
    UnrAddCommentComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule
  ],
})
export class FeedbackModule {
}
